var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile+tablet:hidden bg-grey-100" }, [
    _c("div", { staticClass: "o-wrapper" }, [
      _c(
        "div",
        {
          class: [
            "h-header-top-mobile lg:h-header-top-desktop flex items-center justify-end list-none"
          ]
        },
        [
          _c("nav", [
            _c(
              "ul",
              { staticClass: "flex items-center list-none lg:flex-nowrap" },
              [
                _vm._l(_vm.navItems, function(navItem, index) {
                  return _c(
                    "li",
                    { key: navItem.id, class: index === 0 ? "" : "ml-6" },
                    [
                      _c(
                        "a",
                        {
                          class: [
                            "u-body-md group relative inline-block focus:outline-none",
                            navItem.classes,
                            {
                              "cursor-default": !navItem.url
                            }
                          ],
                          attrs: {
                            href: navItem.url,
                            target: navItem.newWindow ? "_blank" : "_self"
                          }
                        },
                        [
                          _c("span", {
                            class: [
                              "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out"
                            ]
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              class: [
                                "text-grey-800 group-hover:text-primary border-b-2 border-solid group-hover:border-primary border-transparent transition-colors duration-200 ease-in-out"
                              ]
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(navItem.title) +
                                  "\n              "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("li", { staticClass: "ml-6" }, [
                  _c(
                    "a",
                    {
                      class: [
                        "u-body-md group relative flex h-6 focus:outline-none"
                      ],
                      attrs: { href: _vm.savedUrl }
                    },
                    [
                      _c("span", {
                        class: [
                          "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                        ]
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "mr-2 w-6 h-6" }, [
                        _c(
                          "svg",
                          {
                            staticClass: "w-6 h-6",
                            attrs: {
                              width: "32",
                              height: "32",
                              viewBox: "0 0 32 32",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              staticClass:
                                "group-hover:text-primary text-white fill-current transition duration-200 ease-in-out",
                              attrs: {
                                d:
                                  "M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              staticClass:
                                "text-primary fill-current transition duration-200 ease-in-out",
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d:
                                  "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71573 1 1 7.71573 1 16C1 24.2843 7.71573 31 16 31ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                              }
                            }),
                            _vm._v(" "),
                            _c("path", {
                              staticClass:
                                "text-primary group-hover:text-white fill-current transition duration-200 ease-in-out",
                              attrs: {
                                d:
                                  "M21.7941 11.2602C20.189 9.57993 17.5871 9.57993 15.9989 11.2602C14.3939 9.57993 11.792 9.57993 10.2038 11.2602C8.59873 12.9405 8.59873 15.6643 10.2038 17.3269L15.3569 22.7214C15.7117 23.0929 16.3031 23.0929 16.6579 22.7214L21.811 17.3269C23.3991 15.6643 23.3991 12.9405 21.7941 11.2602Z"
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: [
                            "group-hover:border-primary border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out text-grey-800 group-hover:text-primary"
                          ]
                        },
                        [_vm._v("\n                Saved\n              ")]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "ml-6" }, [
                  _c(
                    "a",
                    {
                      class: [
                        "u-body-md group relative inline-flex items-center h-6 focus:outline-none"
                      ],
                      attrs: { href: _vm.searchUrl }
                    },
                    [
                      _c("span", {
                        class: [
                          "absolute -inset-1.5 border-2 border-solid border-grey-900 rounded-lg opacity-0 group-focus:opacity-100 transition-opacity duration-200 ease-in-out pointer-events-none"
                        ]
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          class: [
                            "group-hover:border-primary border-b-2 border-solid border-transparent transition-colors duration-200 ease-in-out text-grey-800 group-hover:text-primary"
                          ]
                        },
                        [_vm._v("\n                Search\n              ")]
                      ),
                      _vm._v(" "),
                      _c("Sprite", {
                        staticClass:
                          "ml-2 w-6 h-6 text-grey-700 group-hover:text-primary",
                        attrs: { id: "icon-search" }
                      })
                    ],
                    1
                  )
                ])
              ],
              2
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }